import { Alert, Collapse, Stack, Typography, useTheme } from "@mui/material"
import { ReactElement, useContext } from "react"

import { ReactComponent as CodingSvg } from "../../../assets/coding.svg"
import useConfirmSetUp, {
    INSTALLER_SOFTWARE_PROVIDER,
} from "../../../services/middleware/hooks/account/useConfirmSetUp"
import AppButton from "../../buttons/appButton"
import AppLoadingButton from "../../buttons/appLoadingButton"
import CheckMarkList from "../../dataDisplay/lsits/checkMarkList"
import { BUTTON_SPACING } from "../common/config"
import FullScreenTitleContent from "../common/fullScreenTitleContent"
import { AccountSetUpContext } from "../providers/firstLoginProvider"
import { SELECT_ORG_TYPE } from "../screenDispatchers/firstLoginConstants"

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore: Unreachable code error
// eslint-disable-next-line no-undef
const CONFIG = GLOBAL_CONFIG

/** Displayed to users expecting an invite */
const SoftwareProviderSetUp = (): ReactElement => {
    const { setCurrentScreen } = useContext(AccountSetUpContext)
    const { isConfirming, error, patchConfirmSetUp } = useConfirmSetUp(
        INSTALLER_SOFTWARE_PROVIDER
    )
    const theme = useTheme()

    return (
        <FullScreenTitleContent
            titlePrimaryColor=""
            titleMain="I am an API Installer or Software Provider"
            subtitle="We have a suite of APIs that allow you to raise and manage connections applications. Our developer portal provides full documentation and guidance on how to use this. We also have a sandbox environment that you can use to test the APIs and your integrations with them! "
            content={
                <>
                    <Typography
                        variant="h6"
                        fontWeight={400}
                        color="text.secondary"
                    >
                        To get access to our APIs:
                    </Typography>
                    <CheckMarkList
                        secondary
                        variant="h6"
                        fontWeight={400}
                        items={[
                            "Click the button below to complete your set up. When you do this, we will do two things",
                            "First, we will update your account so you can access our developer portal",
                            "Second, we will launch our support portal",
                            "Please raise a ticket in the portal and request API keys for either or production or sandbox environment (or both!)",
                            "Our support team will generate your keys and send them to you",
                        ]}
                    />
                </>
            }
            customSvg={
                <CodingSvg width="100%" fill={theme.palette.primary.dark} />
            }
            actionContent={
                <Stack width="100%" spacing={BUTTON_SPACING}>
                    <Collapse in={!!error}>
                        <Stack width="100%" spacing={BUTTON_SPACING}>
                            <Alert severity="warning">
                                {error?.displayDetail}
                            </Alert>
                            <AppButton
                                fullWidth
                                variant="outlined"
                                color="warning"
                                onClick={() =>
                                    window.open(CONFIG.SN_PORTAL_URL, "_blank")
                                }
                                disabled={isConfirming}
                            >
                                Support Portal
                            </AppButton>
                        </Stack>
                    </Collapse>
                    <AppLoadingButton
                        fullWidth
                        variant="contained"
                        loading={isConfirming}
                        onClick={() => {
                            patchConfirmSetUp()
                            window.open(CONFIG.SN_PORTAL_URL, "_blank")
                        }}
                    >
                        Complete set up and go to Support Portal
                    </AppLoadingButton>
                    <AppButton
                        fullWidth
                        variant="outlined"
                        disabled={isConfirming}
                        onClick={() => setCurrentScreen(SELECT_ORG_TYPE)}
                    >
                        Back
                    </AppButton>
                </Stack>
            }
        />
    )
}

export default SoftwareProviderSetUp
